import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import ViewPage from '../../../Components/ViewPage'
import { ContainerAbastecimento } from './styled'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { Dayjs } from 'dayjs'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../services/Equipe'
import { maskCNPJ } from '../../../utils'
import { TabelaAbastecimento } from './components/tabela'
import { FormularioAbastecimento } from './components/formulario'
import { useGetAbastecimento, useGetAbastecimentoTotal } from '../../../services/abastecimento/GET'
import { useDeleteAbastecimento } from '../../../services/abastecimento/DELETE'
import { useGetAtribuicaoFrota, useGetCategoriaPatrimonio } from '../../../services/Patrimonio/atribuicaoFrota/GET'
import { postAbastecimento, putAbastecimento } from '../../../services/abastecimento/POST'
import { FornecedorItens, getFornecedor } from '../../../services/Fornecedores'
import { getPropriedadeLiberada, PropriedadeItens } from '../../../services/Propriedades'
import { localConfig } from '../../../Configs/localConfig'
import secureLocalStorage from 'react-secure-storage'
import {
  apenasCamposAlterados,
  filtrarPostos,
  montarEndereco,
  montarPayloadAbastecimento,
  ValoresAbastecimento,
  valoresDoAbastecimento,
} from './meta'
import { errorAlert } from '../../../utils/alert'

export interface PropsAbastecimento {
  estabelecimento: string
  cnpj: string
  endereco: string
  data: string
  hora: string
  combustivel: string
  litros: string
  precoporlitro: string
  valortotal: string
  formapagto: string
  numeroCupom: string
}

const dadosPagamento = [
  { forma: 'Dinheiro', cod: 1 },
  { forma: 'Cartão de crédito', cod: 2 },
  { forma: 'Cartão de débito', cod: 3 },
  { forma: 'Pix', cod: 4 },
  { forma: 'Boleto bancário', cod: 5 },
  { forma: 'A prazo', cod: 6 }
]

const Abastecimento: React.FC = () => {
  /**Usuário logado, usado para listar apenas as propriedades que ele tem acesso */
  const cod_usuario_logado: number = secureLocalStorage.getItem('Itens')?.[0]?.cod

  //TABELA
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [open, setOpen] = useState(false)
  const [buscar_tabela, setBuscar_tabela] = useState<string>('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //FORMULARIO
  const [update, setUpdate] = useState(0)
  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [nome_posto, setNome_posto] = useState<string>('')
  const [cnpj, setCnpj] = useState<string>('')
  const [endereco, setEndereco] = useState<string>('')
  const [odom_atual, setOdom_atual] = useState<string>('')
  const [qntd_litros, setQntd_litros] = useState<string>('')
  const [valor_total, setValor_total] = useState<string>('')
  const [forma_pagamento, setForma_pagamento] = useState<string>('')
  const [forma_pagamento_id, setForma_pagamento_id] = useState<number>(null)
  const [tipo_combustivel, setTipo_combustivel] = useState<string>('')
  const [tipo_combustivel_id, setTipo_combustivel_id] = useState<number>(null)
  const [data, setData] = useState<Dayjs | null>(null)
  const [hora, setHora] = useState<string>('')
  const [tanque_cheio, setTanque_cheio] = useState<boolean>(false)
  const [usuario_selecionado, setUsuario_selecionado] = useState<string>('')
  const [usuario_selecionado_id, setUsuario_selecionado_id] = useState<number>(null)
  const [veiculo_selecionado, setVeiculo_selecionado] = useState<string>('')
  const [veiculo_selecionado_id, setVeiculo_selecionado_id] = useState<number>(null)
  const [frota, setFrota] = useState<string>('')
  const [selectedFile, setSelectedFile] = useState(null)
  const [base64File, setBase64File] = useState<string>('')
  const [dataEquipe, setDataEquipe] = useState([])
  const [dataVeiculos, setDataVeiculos] = useState([])
  const [imagePreview, setImagePreview] = useState<string | null>(null)
  const [tab_local, setTab_local] = useState<string>('Posto')
  const [posto_selecionado, setPosto_selecionado] = useState<string>('')
  const [posto_selecionado_id, setPosto_selecionado_id] = useState<number>(null)
  const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
  const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(null)
  const [responsavel_custo, setResponsavel_custo] = useState<string>('Empresa')
  const [pagamento_efetuado, setPagamento_efetuado] = useState<boolean>(false)
  const [necessario_reembolso, setNecessario_reembolso] = useState<boolean>(false)
  const [desconto_folha, setDesconto_folha] = useState<boolean>(false)
  const [dataPostos, setDataPostos] = useState<FornecedorItens[]>([])
  const [dataPropriedades, setDataPropriedades] = useState<PropriedadeItens[]>([])
  const [carregando_postos, setCarregando_postos] = useState<boolean>(false)
  const [carregando_propriedades, setCarregando_propriedades] = useState<boolean>(false)
  /**Estado do registro no momento em que a gaveta de edição foi aberta, usado para enviar
   * na atualização apenas o que o usuário mudou */
  const [valores_originais, setValores_originais] = useState<ValoresAbastecimento>(null)

  //API
  const { data_categoria_patrimonio, refetch_data_categoria_patrimonio } =
    useGetCategoriaPatrimonio()
  const { carregando_abastecimento, data_abastecimento, refetch_data_abastecimento } =
    useGetAbastecimento(pagination, page, buscar_tabela)
  const {
    data_abastecimento_total,
    carregando_abastecimento_total,
    refetch_data_abastecimento_total,
  } = useGetAbastecimentoTotal()
  const { carregando_atribuicao, data_atribuicao, refetch_data_atribuicao } =
    useGetAtribuicaoFrota(-1)
  const { carregando_deletar_abastecimento, mudateDeletarAbastecimento } = useDeleteAbastecimento()
  async function listarEquipe() {
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: -1,
      status: 1,
    })
    setDataEquipe(response.data.itens)
  }

  /**Os postos são os fornecedores marcados como posto de combustível */
  async function listarPostos() {
    setCarregando_postos(true)
    try {
      const response = await getFornecedor({
        codCategoria: 1,
        codConta: localConfig()?.conta,
        codCliente: localConfig()?.codCliente,
        pagination: -1,
      })

      setDataPostos(filtrarPostos(response?.data?.itens))
    } catch {
      setDataPostos([])
      errorAlert('Falha ao obter a lista de postos!')
    } finally {
      setCarregando_postos(false)
    }
  }

  /**Lista as propriedades liberadas para o usuário logado, usada tanto na gaveta
   * de cadastro quanto no filtro avançado
  */
  async function listarPropriedades() {
    setCarregando_propriedades(true)
    try {
      const response = await getPropriedadeLiberada(cod_usuario_logado)
      setDataPropriedades(response?.data?.itens.filter(item => item?.status === 1) ?? [])
    } catch {
      setDataPropriedades([])
      errorAlert('Falha ao obter as propriedades liberadas para o usuário!')
    } finally {
      setCarregando_propriedades(false)
    }
  }

  /**Ao selecionar o posto, os dados do fornecedor preenchem os campos do formulário */
  function selecionarPosto(cod: number) {
    setPosto_selecionado_id(cod)

    const posto = dataPostos?.find((item) => item?.cod === cod)

    setNome_posto(posto?.nome ?? '')
    setCnpj(maskCNPJ(posto?.cpf_cnpj))
    setEndereco(montarEndereco(posto))
  }

  /**Trocar o usuário troca a lista de propriedades liberadas, então a seleção anterior é descartada */
  function selecionarUsuario(cod: number) {
    setUsuario_selecionado_id(cod)
    setPropriedade_selecionada('')
    setPropriedade_selecionada_id(null)
  }

  /**Cada local usa um conjunto de campos, então trocar a aba limpa o que não pertence ao outro */
  function selecionarLocal(tab: string) {
    setTab_local(tab)

    if (tab === 'Posto') {
      setPropriedade_selecionada('')
      setPropriedade_selecionada_id(null)
      return
    }

    limparCamposPosto()
  }

  function limparCamposPosto() {
    setPosto_selecionado('')
    setPosto_selecionado_id(null)
    setNome_posto('')
    setCnpj('')
    setEndereco('')
    setForma_pagamento('')
    setForma_pagamento_id(null)
    setResponsavel_custo('Empresa')
    setPagamento_efetuado(false)
    setNecessario_reembolso(false)
    setDesconto_folha(false)
  }

  /**Reúne os valores que estão nos campos no formato usado para montar o payload */
  function valoresDoFormulario(): ValoresAbastecimento {
    return {
      veiculo_selecionado_id: veiculo_selecionado_id,
      usuario_selecionado_id: usuario_selecionado_id,
      tab_local: tab_local,
      posto_selecionado_id: posto_selecionado_id,
      nome_posto: nome_posto,
      cnpj: cnpj,
      endereco: endereco,
      propriedade_selecionada_id: propriedade_selecionada_id,
      odom_atual: odom_atual,
      qntd_litros: qntd_litros,
      valor_total: valor_total,
      tipo_combustivel_id: tipo_combustivel_id,
      data: data,
      hora: hora,
      tanque_cheio: tanque_cheio,
      pagamento_efetuado: pagamento_efetuado,
      responsavel_custo: responsavel_custo,
      necessario_reembolso: necessario_reembolso,
      desconto_folha: desconto_folha,
      forma_pagamento_id: forma_pagamento_id,
      arquivo: selectedFile,
    }
  }

  async function salvarAbastecimento() {
    setLoadingSalvar(true)
    const dataAbastecimento = montarPayloadAbastecimento(valoresDoFormulario())

    if (update <= 0) {
      await postAbastecimento(
        dataAbastecimento,
        fecharGaveta,
        setLoadingSalvar,

      )
      return
    }

    /**Na atualização vai apenas o que mudou em relação ao registro aberto na gaveta */
    const alterados = apenasCamposAlterados(
      dataAbastecimento,
      montarPayloadAbastecimento(valores_originais)
    )

    await putAbastecimento(
      alterados,
      update,
      fecharGaveta,
      setLoadingSalvar,
    )
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function limparCampos() {
    setNome_posto('')
    setCnpj('')
    setEndereco('')
    setOdom_atual('')
    setQntd_litros('')
    setValor_total('')
    setTipo_combustivel('')
    setTipo_combustivel_id(null)
    setData(null)
    setHora('')
    setTanque_cheio(false)
    setSelectedFile(null)
    setBase64File('')
    setPosto_selecionado('')
    setPosto_selecionado_id(null)
    setPropriedade_selecionada('')
    setPropriedade_selecionada_id(null)
    setResponsavel_custo('Empresa')
    setPagamento_efetuado(false)
    setNecessario_reembolso(false)
    setDesconto_folha(false)
  }

  function editarGaveta(item) {
    setUpdate(item?.cod)
    const valores = valoresDoAbastecimento(item)

    /**Guardado antes de preencher os campos, para depois saber o que o usuário mudou */
    setValores_originais(valores)

    setUsuario_selecionado(item?.usuario_nome)
    setUsuario_selecionado_id(valores.usuario_selecionado_id)
    setVeiculo_selecionado(item?.veiculo_nome)
    setVeiculo_selecionado_id(valores.veiculo_selecionado_id)
    setNome_posto(valores.nome_posto)
    setCnpj(valores.cnpj)
    setEndereco(valores.endereco)
    setTipo_combustivel(item?.tipo_combustivel_nome)
    setTipo_combustivel_id(valores.tipo_combustivel_id)
    setQntd_litros(valores.qntd_litros)
    setValor_total(valores.valor_total)
    setData(valores.data)
    setHora(valores.hora)
    setFrota(item?.frota)
    setOdom_atual(valores.odom_atual)
    setImagePreview(item?.cupom_fiscal_url)
    setTanque_cheio(valores.tanque_cheio)
    setTab_local(valores.tab_local)
    setPosto_selecionado(item?.nome_posto)
    setPosto_selecionado_id(valores.posto_selecionado_id)
    setPropriedade_selecionada(item?.propriedade_nome ?? '')
    setPropriedade_selecionada_id(valores.propriedade_selecionada_id)
    setPagamento_efetuado(valores.pagamento_efetuado)
    setNecessario_reembolso(valores.necessario_reembolso)
    setDesconto_folha(valores.desconto_folha)
    setForma_pagamento(item?.forma_pagamento_nome)
    setForma_pagamento_id(valores.forma_pagamento_id)
    setResponsavel_custo(valores.responsavel_custo)
    setOpen(true)
  }

  function deletar(cod) {
    setFake_loading(true)
    mudateDeletarAbastecimento({
      cod_abastecimento: cod,
      refetch_deletar: refetch_data_abastecimento
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 800);
  }

  const handleImageChange = async (file: File | null, base) => {
    if (file !== null) {
      console.log('file', file)
      setBase64File(base)
      setSelectedFile(file)
    }
  }

  function fecharGaveta() {
    setOpen(false)
    setUpdate(0)
    setValores_originais(null)
    setNome_posto('')
    setCnpj('')
    setEndereco('')
    setOdom_atual('')
    setQntd_litros('')
    setValor_total('')
    setTipo_combustivel('')
    setTipo_combustivel_id(null)
    setData(null)
    setHora('')
    setFrota('')
    setTanque_cheio(false)
    setUsuario_selecionado('')
    setUsuario_selecionado_id(null)
    setVeiculo_selecionado('')
    setVeiculo_selecionado_id(null)
    setBase64File('')
    setForma_pagamento('')
    setForma_pagamento_id(null)
    setImagePreview(null)
    setSelectedFile(null)
    setTab_local('Posto')
    setPosto_selecionado('')
    setPosto_selecionado_id(null)
    setPropriedade_selecionada('')
    setPropriedade_selecionada_id(null)
    setResponsavel_custo('Empresa')
    setPagamento_efetuado(false)
    setNecessario_reembolso(false)
    setDesconto_folha(false)
    refetch_data_abastecimento()
  }

  useEffect(() => {
    if (data_categoria_patrimonio?.itens?.length > 0) {

      setDataVeiculos(data_categoria_patrimonio?.itens)
    }
  }, [data_categoria_patrimonio])

  useEffect(() => {
    if (usuario_selecionado_id !== null && update <= 0) {
      const filter = data_atribuicao?.itens.filter(
        (item) => item?.cod_usuario === usuario_selecionado_id
      )
      setVeiculo_selecionado(filter[0]?.veiculo_nome)
      setVeiculo_selecionado_id(filter[0]?.cod_veiculo)
      setFrota(filter[0]?.frota)
    }
  }, [usuario_selecionado_id])

  // useEffect(() => {
  //   if (selectedFile !== null && base64File !== '') {
  //     mutate_analise_ai({
  //       base64: base64File?.replace(/^data:.*;base64,/, ''),
  //       mimeType: selectedFile?.type,
  //       refetch: undefined,
  //     })
  //   }
  // }, [selectedFile, base64File])

  // useEffect(() => {
  //   if (data_abastecimento_ai !== undefined) {
  //     const dados: PropsAbastecimento = data_abastecimento_ai?.data?.itens[0]
  //     const filterCombustivel = combustiveis.filter(
  //       (item) =>
  //         item.nome.toLowerCase() === dados?.combustivel?.trim().split(/\s+/)[0]?.toLowerCase()
  //     )
  //     const filterForma = dadosPagamento.filter(
  //       (item) => item?.forma.toLowerCase() === dados?.formapagto.toLowerCase()
  //     )
  //     setNome_posto(dados?.estabelecimento)
  //     setCnpj(maskCNPJ(dados?.cnpj))
  //     setEndereco(dados?.endereco)
  //     setTipo_combustivel(filterCombustivel[0]?.nome)
  //     setTipo_combustivel_id(filterCombustivel[0]?.cod)
  //     setQntd_litros(mascararValorInicial(dados?.litros))
  //     setValor_total(mascararValorInicial(dados?.valortotal))
  //     setData(dayjs(dados?.data, 'DD/MM/YYYY'))
  //     setForma_pagamento(filterForma[0]?.forma)
  //     setForma_pagamento_id(filterForma[0]?.cod)
  //     setHora(dados?.hora)
  //   }
  // }, [data_abastecimento_ai])

  useEffect(() => {
    refetch_data_abastecimento()
  }, [page, pagination])

  useEffect(() => {
    if (buscar_tabela.length > 2) {
      setTimeout(() => {
        refetch_data_abastecimento();
      }, 700);
    }
    if (buscar_tabela === '') {
      refetch_data_abastecimento();
    }
  }, [buscar_tabela])

  useEffect(() => {
    listarEquipe()
    listarPostos()
    listarPropriedades()
    refetch_data_atribuicao()
    refetch_data_categoria_patrimonio()
    refetch_data_abastecimento()
    refetch_data_abastecimento_total()
  }, [])

  return (
    <ContainerAbastecimento>
      <ViewPage
        title='Abastecimento'
        btnClick={null}
        newHide
        rotina={109}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Abastecimento</TitleH1>
        </div>

        <TabelaAbastecimento
          loading={carregando_abastecimento}
          carregando_total={carregando_abastecimento_total}
          pagination={pagination}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={data_abastecimento?.total}
          listar_abastecimento={data_abastecimento?.itens}
          data_postos={dataPostos}
          data_propriedades={dataPropriedades}
          abrir={abrirGaveta}
          permissao={permissions}
          editar={editarGaveta}
          deletar={deletar}
          buscar_tabela={buscar_tabela}
          setBuscar_tabela={setBuscar_tabela}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          total_geral={data_abastecimento_total?.itens}
        />

        <FormularioAbastecimento
          openForm={open}
          fecharGaveta={fecharGaveta}
          salvarAbastecimento={salvarAbastecimento}
          carregando_abastecimento={loadingSalvar}
          update={update}
          nome_posto={nome_posto}
          setNome_posto={setNome_posto}
          cnpj={cnpj}
          setCnpj={setCnpj}
          endereco={endereco}
          setEndereco={setEndereco}
          odom_atual={odom_atual}
          setOdom_atual={setOdom_atual}
          qtnd_litros={qntd_litros}
          setQtnd_litros={setQntd_litros}
          valor_total={valor_total}
          setValor_total={setValor_total}
          forma_pagamento={forma_pagamento}
          setForma_pagamento={setForma_pagamento}
          setForma_pagamento_id={setForma_pagamento_id}
          tipo_combustivel={tipo_combustivel}
          setTipo_combustivel={setTipo_combustivel}
          setTipo_combustivel_id={setTipo_combustivel_id}
          data={data}
          setData={setData}
          hora={hora}
          setHora={setHora}
          tanque_cheio={tanque_cheio}
          setTanque_cheio={setTanque_cheio}
          usuario_selecionado={usuario_selecionado}
          setUsuario_selecionado={setUsuario_selecionado}
          setUsuario_selecionado_id={selecionarUsuario}
          veiculo_selecionado={veiculo_selecionado}
          setVeiculo_selecionado={setVeiculo_selecionado}
          setVeiculo_selecionado_id={setVeiculo_selecionado_id}
          frota={frota}
          setFrota={setFrota}
          imagePreview={imagePreview}
          handleChangeImage={handleImageChange}
          // loading_abastecimento_ai={carregando_analise_ai}
          data_equipe={dataEquipe}
          data_veiculos={dataVeiculos}
          data_pagamento={dadosPagamento}
          limparCampos={limparCampos}
          permissions={permissions}
          tab_local={tab_local}
          selecionarLocal={selecionarLocal}
          posto_selecionado={posto_selecionado}
          setPosto_selecionado={setPosto_selecionado}
          selecionarPosto={selecionarPosto}
          propriedade_selecionada={propriedade_selecionada}
          setPropriedade_selecionada={setPropriedade_selecionada}
          setPropriedade_selecionada_id={setPropriedade_selecionada_id}
          responsavel_custo={responsavel_custo}
          setResponsavel_custo={setResponsavel_custo}
          pagamento_efetuado={pagamento_efetuado}
          setPagamento_efetuado={setPagamento_efetuado}
          necessario_reembolso={necessario_reembolso}
          setNecessario_reembolso={setNecessario_reembolso}
          desconto_folha={desconto_folha}
          setDesconto_folha={setDesconto_folha}
          data_postos={dataPostos}
          data_propriedades={dataPropriedades}
          carregando_postos={carregando_postos}
          carregando_propriedades={carregando_propriedades}
        />
      </ViewPage>
    </ContainerAbastecimento>
  )
}

export default Abastecimento